import React, { useRef, useState, useEffect, useContext } from "react";
// ===========================
// [BARCODE-SCAN] تم التعطيل
// import ScanBarcodes from "./ScanBarcodes";
// ===========================
import { RunnerContext } from "../Main";

/** ================= Helpers: LocalStorage ================= **/
const COMPANY_CODE_KEY = "company_code"; // اللي بيتخزن من شاشة اللوجين
const COMPANY_ID_KEY = "companyId"; // بيتخزن بعد اللوجين
const ACCESS_TOKEN_KEY = "accessToken";

const getCompanyIdFromLocal = (fallback = "") => {
  try {
    const fromCode = (localStorage.getItem(COMPANY_CODE_KEY) || "").trim();
    const fromId = (localStorage.getItem(COMPANY_ID_KEY) || "").trim();
    const v = fromCode || fromId || String(fallback || "");
    return v;
  } catch {
    return String(fallback || "");
  }
};

const getAccessTokenFromLocal = (fallback = "") => {
  try {
    return (
      (localStorage.getItem(ACCESS_TOKEN_KEY) || "").trim() ||
      String(fallback || "")
    );
  } catch {
    return String(fallback || "");
  }
};

export default function ShipmentScanner() {
  const { runnerData } = useContext(RunnerContext);

  // start | camera | form | done
  const [step, setStep] = useState("start");
  const [piecesCount, setPiecesCount] = useState(0);
  const [policyNumber, setPolicyNumber] = useState("");
  // const [barcodes, setBarcodes] = useState([]); // [BARCODE-SCAN] معطّل
  const [photoFile, setPhotoFile] = useState(null);

  const [isSaving, setIsSaving] = useState(false); // ⏳ لودينج وقت الحفظ

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);

  // زر "حفظ"
  const saveBtnRef = useRef(null);
  const fileInputRef = useRef(null);

  const handleStartCamera = async () => setStep("camera");

  // ✅ زر تسجيل الخروج: يمسح اللوكل ستوريدج ويروح للّوجين
  const handleLogout = () => {
    try {
      localStorage.clear();
    } catch (e) {
      // تجاهل
    } finally {
      window.location.href = "/login";
    }
  };

  useEffect(() => {
    if (step === "camera") startCamera();
    return () => stopCamera();
  }, [step]);

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" },
      });
      streamRef.current = stream;
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
    } catch (err) {
      alert("🚫 لا يمكن الوصول إلى الكاميرا. تأكد من إعطاء الصلاحية.");
      console.error(err);
    }
  };

  const stopCamera = () => {
    streamRef.current?.getTracks().forEach((t) => t.stop());
  };

  const handleCapture = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas) return;

    const ctx = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob((blob) => {
      if (blob) {
        const file = new File([blob], "shipment.jpg", { type: "image/jpeg" });
        setPhotoFile(file);
        stopCamera();
        setStep("form");
      } else {
        alert("❌ فشل في التقاط الصورة");
      }
    }, "image/jpeg");
  };

  const handleAttachImage = () => {
    try {
      fileInputRef.current?.click();
    } catch (e) {
      console.error(e);
    }
  };

  const onFileSelected = (e) => {
    const f = e?.target?.files?.[0];
    if (f) {
      setPhotoFile(f);
      setStep("form");
    }
    // clear the input so selecting the same file again will fire change
    if (e && e.target) e.target.value = "";
  };

  // إرسال: policyNumber + pieces (بعدد القطع) + الصورة. باقي الحقول فاضية.
  const handleSave = async () => {
    if (!policyNumber.trim() || Number(piecesCount) <= 0) {
      alert("📝 يرجى إدخال رقم البوليصة وعدد القطع بشكل صحيح");
      return;
    }
    if (!photoFile) {
      alert("📷 يرجى التقاط صورة أولاً قبل الحفظ");
      return;
    }

    // اجلب التوكين والكمباني آي دي من الـ context ثم localStorage
    const accessToken =
      runnerData?.data?.accessToken || getAccessTokenFromLocal("") || "";
    const companyId =
      runnerData?.data?.companyId || getCompanyIdFromLocal("") || "";

    if (!companyId || !accessToken) {
      alert("⚠️ CompanyID أو AccessToken غير موجودين. تأكد من تسجيل الدخول.");
      console.error("Missing headers:", { companyId, accessToken });
      return;
    }

    setIsSaving(true); // ⏳ ابدأ اللودينج

    try {
      const formData = new FormData();
      formData.append("policyNumber", String(policyNumber).trim());

      // ✅ المطلوب: ابعت عدد القطع في pieces (وليس piecesCount)
      formData.append("pieces", String(piecesCount));

      // بقية الحقول فاضية حسب طلبك
      formData.append("notes", "");
      formData.append("file", photoFile);

      const res = await fetch(
        "https://vsoftopim2dev.com-eg.net/api/Policy/V1/AddPolicy",
        {
          method: "POST",
          headers: {
            CompanyID: String(companyId),
            AccessToken: String(accessToken),
            Accept: "application/json",
            // مهم: لا تضيف Content-Type مع FormData
          },
          body: formData,
        }
      );

      // ✅ لو 400 أو 401: امسح الكاش وروّح اللوجين
      if (res.status === 400 || res.status === 401) {
        try {
          localStorage.clear();
        } catch {}
        alert("⛔ انتهت الجلسة أو الطلب غير صالح. يرجى تسجيل الدخول مرة أخرى.");
        window.location.href = "/login";
        return;
      }

      let payload = null;
      let text = "";
      try {
        payload = await res.json();
      } catch {
        try {
          text = await res.text();
        } catch {
          /* ignore */
        }
      }

      if (!res.ok) {
        const serverMsg =
          (payload &&
            (payload.message || payload.error || JSON.stringify(payload))) ||
          text ||
          `HTTP ${res.status}`;
        alert("❌ حدث خطأ أثناء الإرسال: " + serverMsg);
        console.error("Submit Error:", {
          status: res.status,
          serverMsg,
          payload,
          text,
        });
        return;
      }

      setStep("done");
    } catch (err) {
      alert("❌ حدث خطأ أثناء الإرسال (شبكة/خادم). راجع الكونسول للتفاصيل.");
      console.error(err);
    } finally {
      setIsSaving(false); // ✅ أوقف اللودينج في جميع الحالات
    }
  };

  useEffect(() => {
    if (step === "form" && policyNumber.trim() && Number(piecesCount) > 0) {
      saveBtnRef.current?.focus();
      saveBtnRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [piecesCount, policyNumber, step]);

  const onPiecesKeyDown = (e) => {
    if (e.key === "Enter" && !isSaving) handleSave();
  };

  const resetAll = () => {
    setPiecesCount(0);
    setPolicyNumber("");
    // setBarcodes([]); // [BARCODE-SCAN]
    setPhotoFile(null);
  };

  return (
    <div
      style={{
        padding: 20,
        maxWidth: 500,
        margin: "auto",
        position: "relative",
      }}
    >
      {step === "start" && (
        <>
          <button style={styles.button} onClick={handleStartCamera}>
            📸 فتح الكاميرا
          </button>

          <button
            style={{ ...styles.secondaryButton, marginTop: 8 }}
            onClick={handleAttachImage}
          >
            🖼️ إرفاق صورة
          </button>

          {/* hidden file input for gallery selection */}
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={onFileSelected}
            disabled={isSaving}
          />

          {/* ✅ زر تسجيل الخروج */}
          <button style={styles.logoutButton} onClick={handleLogout}>
            🚪 تسجيل الخروج
          </button>
        </>
      )}

      {step === "camera" && (
        <div style={styles.section}>
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            style={{ width: "100%", borderRadius: 8 }}
          />
          <button
            style={styles.button}
            onClick={handleCapture}
            disabled={isSaving}
          >
            📷 التقط الصورة
          </button>
          <canvas ref={canvasRef} style={{ display: "none" }} />
        </div>
      )}

      {step === "form" && (
        <div style={styles.section} aria-busy={isSaving}>
          <label style={styles.label}>: رقم البوليصة</label>
          <input
            type="text"
            value={policyNumber}
            onChange={(e) => setPolicyNumber(e.target.value)}
            style={styles.input}
            disabled={isSaving}
          />

          <label style={styles.label}>: عدد القطع</label>
          <input
            type="number"
            value={piecesCount}
            onChange={(e) => setPiecesCount(Number(e.target.value))}
            onKeyDown={onPiecesKeyDown}
            style={styles.input}
            min={1}
            disabled={isSaving}
          />

          {/* حفظ بدون اسكان باركود */}
          <button
            ref={saveBtnRef}
            style={{
              ...styles.button,
              opacity: isSaving ? 0.7 : 1,
              pointerEvents: isSaving ? "none" : "auto",
            }}
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? "⏳ جاري الحفظ..." : "💾 حفظ"}
          </button>

          {/* إعادة التصوير */}
          <button
            style={styles.secondaryButton}
            onClick={() => setStep("camera")}
            disabled={isSaving}
          >
            🎞️ إعادة التصوير
          </button>
        </div>
      )}

      {/* 
      [BARCODE-SCAN] — معطّل حاليًا.

      {step === "scan" && (
        <>
          <button
            style={styles.secondaryButton}
            onClick={() => setStep("form")}
          >
            ⬅️ عودة
          </button>
          <ScanBarcodes
            expectedCount={piecesCount}
            onComplete={(scanned) => {
              setBarcodes(scanned);
              handleCompleteScanning(scanned);
            }}
          />
        </>
      )}
      */}

      {step === "done" && (
        <div style={styles.doneBox}>
          ✅ تم إرسال الشحنة بنجاح.
          <div style={{ fontSize: 14, marginTop: 8, direction: "rtl" }}>
            رقم البوليصة: <b>{policyNumber || "-"}</b> — عدد القطع:{" "}
            <b>{piecesCount || 0}</b>
          </div>
          <div style={{ marginTop: 12, display: "grid", gap: 8 }}>
            <button
              style={styles.button}
              onClick={() => {
                resetAll();
                setStep("camera");
              }}
            >
              📸 تصوير شحنة جديدة
            </button>
            <button
              style={styles.secondaryButton}
              onClick={() => {
                resetAll();
                setStep("start");
              }}
            >
              🏁 العودة للبداية
            </button>
          </div>
        </div>
      )}

      {/* ✅ Overlay تحميل عام أثناء الحفظ */}
      {isSaving && (
        <div style={styles.loadingOverlay}>
          <div style={styles.loader} />
          <div style={{ marginTop: 12, fontWeight: 600 }}>⏳ جاري الحفظ...</div>
        </div>
      )}
    </div>
  );
}

const styles = {
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#1976d2",
    color: "white",
    border: "none",
    borderRadius: "6px",
    marginTop: "10px",
    width: "100%",
    cursor: "pointer",
  },
  logoutButton: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#d32f2f",
    color: "white",
    border: "none",
    borderRadius: "6px",
    marginTop: "10px",
    width: "100%",
    cursor: "pointer",
  },
  secondaryButton: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#00cc3dff",
    color: "#333",
    border: "none",
    borderRadius: "6px",
    marginTop: "10px",
    marginBottom: "10px",
    width: "100%",
    cursor: "pointer",
  },
  input: {
    padding: 10,
    fontSize: "16px",
    marginTop: "10px",
    width: "100%",
    boxSizing: "border-box",
  },
  label: {
    fontWeight: "bold",
    display: "block",
    marginBottom: "5px",
    textAlign: "right",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    position: "relative",
  },
  doneBox: {
    padding: 15,
    backgroundColor: "#dff0d8",
    borderRadius: 8,
    textAlign: "center",
    marginTop: 20,
  },
  loadingOverlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(255,255,255,0.7)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
  },
  loader: {
    width: 28,
    height: 28,
    border: "3px solid #1976d2",
    borderTopColor: "transparent",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
};

// 👇 إضافة أنيميشن لللودر (Inject CSS once)
if (
  typeof document !== "undefined" &&
  !document.getElementById("spin-keyframes")
) {
  const style = document.createElement("style");
  style.id = "spin-keyframes";
  style.innerHTML = `
    @keyframes spin { 
      to { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
}
